import React from "react";
import { ShieldCheck, FileText, Stethoscope } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function TheResolveClinicalModel() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const features = [{
    title: "Clinical Oversight",
    description: "We operate as a clinically informed service, integrating psychosocial recovery coaching with professional oversight to ensure safe, effective, and therapeutic support pathways.",
    icon: Stethoscope
  }, {
    title: "Documentation-Driven",
    description: "Our practice focuses on clear, evidence-based reporting and transparent billing. We deliver structured support with measurable outcomes to show progress and support ongoing funding.",
    icon: FileText
  }, {
    title: "Ethical Compliance",
    description: "We currently operate as an independent (unregistered) NDIS provider. This allows us to offer flexible, responsive, and personalised supports to self-managed and plan-managed participants.\nOur practice is grounded in social work ethics, trauma-informed care, and compliance with NDIS Code of Conduct requirements.",
    icon: ShieldCheck
  }];
  return <section id="the-resolve-clinical-model" ref={ref} className="dark bg-background text-foreground py-32 relative overflow-hidden">
      <div className="container mx-auto px-6 md:px-12">
        <div className={cn("transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <h2 className="font-serif text-4xl md:text-5xl text-center text-white mb-20 tracking-tight">
            The Resolve Clinical Model
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-16">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={i} data-index={i} className={cn("flex flex-col items-center text-center group transition-all duration-1000 ease-out delay-150", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")} style={{
            transitionDelay: `${150 + i * 150}ms`
          }}>
                <div className="mb-6 p-4 rounded-2xl bg-white/5 ring-1 ring-white/10 shadow-lg backdrop-blur-sm transition-transform duration-300 group-hover:scale-110 group-hover:bg-white/10">
                  <Icon className="w-10 h-10 text-[var(--ring)]" strokeWidth={1.5} />
                </div>
                <h3 className="text-xl font-semibold text-white mb-4 tracking-wide">
                  {feature.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed max-w-sm">
                  {feature.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}